import _ from "underscore";

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

class DownloadButton extends Component {
  constructor() {
    super();
    _.bindAll(this,
      'handleClick'
    );
  }

  handleClick(e) {
    if (!this.props.recordingUrl) {
      e.preventDefault();
    }
  }

  render() {
    return (
      <div className="browser-audio-download-button">
        <div className={ClassNames("browser-audio-control", "browser-audio-call-record-id", { 'ui-hidden': !this.props.recordTitle && !this.props.recordId })}>
          {this.props.recordTitle && <b>{this.props.recordTitle}:</b>} {this.props.recordId}
        </div>
        <a
          className="browser-audio-save-icon-container"
          href={this.props.recordingUrl}
          // eslint-disable-next-line react/jsx-no-target-blank
          target="_blank"
          onClick={this.handleClick}><i className="material-icons browser-audio-save-icon" aria-hidden="true">file_download</i>
        </a>
      </div>
    );
  }
}

DownloadButton.propTypes = {
  recordTitle: PropTypes.string,
  recordId: PropTypes.string.isRequired,
  recordingUrl: PropTypes.string
};

export default DownloadButton;
